export default __webpack_public_path__ + "static/media/Rectangle 13360.f68ea0de.svg";